import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import { devTime, devTimeEnd } from './lib/devLog';

devTime('[App] Initial mount');

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>
);

devTimeEnd('[App] Initial mount');